import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/auth/AuthShell";
import { OtpStep } from "@/pages/auth/OtpStep";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const useAfterLogin = () => {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { applySession } = useAuth();
  return (data) => {
    applySession(data);
    const next = params.get("next");
    nav(next || (data.user.role === "admin" ? "/admin" : "/app"), { replace: true });
  };
};

export default function Login() {
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const done = useAfterLogin();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", f);
      if (data.otp_required) setChallenge(data);
      else done(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={challenge ? "Check your email" : "Welcome back"} subtitle={challenge ? "Enter your verification code" : "Log in to your Sliance workspace"}>
      {challenge ? (
        <OtpStep challenge={challenge} onSuccess={done} onBack={() => setChallenge(null)} />
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div className="space-y-2"><Label>Email</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email-input" className="h-12" /></div>
          <div className="space-y-2">
            <div className="flex justify-between"><Label>Password</Label><Link to="/forgot-password" className="text-xs text-[#7c3aed]" data-testid="login-forgot-password-link">Forgot password?</Link></div>
            <Input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password-input" className="h-12" />
          </div>
          <button disabled={busy} className="btn-brand w-full disabled:opacity-60" data-testid="login-submit-button">{busy ? "Signing in..." : "Log In"}</button>
          <p className="text-sm text-muted-foreground text-center">New to Sliance? <Link to="/register" className="font-semibold text-[#7c3aed]" data-testid="login-register-link">Create a free account</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
